var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pointer",on:{"click":_vm.clicked}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.getSrc,"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }